var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { scSwapDataToSwapData } from "./typeSwap";
import { AVOID_LIST } from "./avoidList";
import { checkEnvOpts } from "./check";
import { NEOSWAP_PROGRAM_ID, VERSION } from "./const";
import { delay } from "./delay";
export function getSdaData(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var swapDataAccount, program, swapData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("getSdaData", VERSION);
                    swapDataAccount = Data.swapDataAccount;
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 1:
                    program = (_a.sent()).program;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, program.account.swapData.fetch(swapDataAccount)];
                case 3:
                    swapData = (_a.sent());
                    if (!swapData) {
                        throw "No SwapData found ".concat(swapDataAccount);
                    }
                    else {
                        return [2 /*return*/, scSwapDataToSwapData(swapData)];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: error_1,
                    };
                case 5: return [2 /*return*/];
            }
        });
    });
}
export function getOpenSda(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var program, swapDatas_1, openSda, openPda_1, error_2;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("getOpenSda", VERSION);
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 1:
                    program = (_a.sent()).program;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 8, , 9]);
                    console.log("Program Id", program.programId.toString());
                    swapDatas_1 = [];
                    if (!(program.programId.toString() === NEOSWAP_PROGRAM_ID)) return [3 /*break*/, 4];
                    return [4 /*yield*/, program.account.swapData.all()];
                case 3:
                    openSda = _a.sent();
                    console.log("openSda len :", openSda.length);
                    openSda.map(function (x) {
                        var sda = x.publicKey.toString();
                        try {
                            swapDatas_1.push({
                                data: scSwapDataToSwapData(x.account),
                                sda: sda,
                            });
                        }
                        catch (error) {
                            console.log(sda, "error feching ", error, x.account);
                        }
                    });
                    console.log("swapDatas", swapDatas_1.length);
                    return [3 /*break*/, 7];
                case 4:
                    console.log("not NSWP");
                    return [4 /*yield*/, program.provider.connection.getParsedProgramAccounts(program.programId)];
                case 5:
                    openPda_1 = _a.sent();
                    console.log("openPda", openPda_1.length);
                    AVOID_LIST.forEach(function (x) {
                        openPda_1 = openPda_1.filter(function (y) { return y.pubkey.toString() !== x; });
                    });
                    return [4 /*yield*/, Promise.all(openPda_1.map(function (x, i) { return __awaiter(_this, void 0, void 0, function () {
                            var sdaData, error_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, delay(i * 100)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([2, 4, , 5]);
                                        return [4 /*yield*/, program.account.swapData.fetch(x.pubkey)];
                                    case 3:
                                        sdaData = (_a.sent());
                                        swapDatas_1.push({
                                            sda: x.pubkey.toString(),
                                            data: scSwapDataToSwapData(sdaData),
                                        });
                                        return [3 /*break*/, 5];
                                    case 4:
                                        error_3 = _a.sent();
                                        console.log(i, " - ", x.pubkey.toString(), "error feching ", error_3);
                                        return [3 /*break*/, 5];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 6:
                    _a.sent();
                    console.log("swapDatas", swapDatas_1);
                    _a.label = 7;
                case 7: return [2 /*return*/, swapDatas_1];
                case 8:
                    error_2 = _a.sent();
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: error_2,
                    };
                case 9: return [2 /*return*/];
            }
        });
    });
}
